query Tests(
	$offset: Int!
	$limit: Int!
	$textSearch: wsdk_test_runsSearchInsensitive
	$sort: wsdk_test_runsSort
	$daysAmountFilter: ConditionInt
	$propertiesFilter: ConditionID
	$environmentCustomFieldsFilter: ConditionStringArray
	$environmentsFilter: ConditionString
	$flowsFilter: ConditionString
	$flowsCustomFieldsFilter: ConditionStringArray
	$otherCustomFieldsFilter: ConditionStringArray
	$unitIdCustomFieldsFilter: ConditionStringArray
	$environmentsEqAnyItem: ConditionString
	$environmentCustomFieldsNeTupleKey: ConditionString
	$unitIdCustomFieldsNeTupleKey: ConditionString
) {
	wsdk_test_runs(
		text_contains: $textSearch
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
		and: [
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter },
					{ environments_eq_any_item: $environmentsFilter },
					{
						and: [
							{ custom_fields_ne_tuple_key: $environmentCustomFieldsNeTupleKey }
							{ environments_eq_any_item: $environmentsEqAnyItem }
						]
					}
				]
			},
			{
				or: [
					{ flows_eq_any_item: $flowsFilter },
					{ custom_fields_eq_any_item_for_any_value: $flowsCustomFieldsFilter },
					{ custom_fields_eq_any_item_for_any_value: $otherCustomFieldsFilter }
				]
			},
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $unitIdCustomFieldsFilter },
					{ custom_fields_ne_tuple_key: $unitIdCustomFieldsNeTupleKey }
				]
			}
		]
	) {
		run_id
		test_name
		total_issues
		critical_issues
		run_time
		custom_fields
		environments
		flows
		test_path
		property_ids
	}
	total: wsdk_test_runs(
		text_contains: $textSearch
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
		and: [
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter },
					{ environments_eq_any_item: $environmentsFilter },
					{
						and: [
							{ custom_fields_ne_tuple_key: $environmentCustomFieldsNeTupleKey }
							{ environments_eq_any_item: $environmentsEqAnyItem }
						]
					}
				]
			},

			{
				or: [
					{ flows_eq_any_item: $flowsFilter },
					{ custom_fields_eq_any_item_for_any_value: $flowsCustomFieldsFilter },
					{ custom_fields_eq_any_item_for_any_value: $otherCustomFieldsFilter }
				]
			},
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $unitIdCustomFieldsFilter },
					{ custom_fields_ne_tuple_key: $unitIdCustomFieldsNeTupleKey }
				]
			}
		]
	) {
		run_id_count
	}
	unfiltered_total: wsdk_test_runs {
		run_id_count
	}
}

query RecentTests(
	$offset: Int!
	$limit: Int!
	$textSearch: wsdk_latest_test_runsSearchInsensitive
	$sort: wsdk_latest_test_runsSort
	$daysAmountFilter: ConditionInt
	$propertiesFilter: ConditionID
	$environmentCustomFieldsFilter: ConditionStringArray
	$environmentsFilter: ConditionString
	$flowsFilter: ConditionString
	$flowsCustomFieldsFilter: ConditionStringArray
	$otherCustomFieldsFilter: ConditionStringArray
	$unitIdCustomFieldsFilter: ConditionStringArray
	$environmentCustomFieldsNeTupleKey: ConditionString
	$unitIdCustomFieldsNeTupleKey: ConditionString
	$environmentsEqAnyItem: ConditionString
) {
	wsdk_test_runs: wsdk_latest_test_runs(
		text_contains: $textSearch
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
		and: [
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter },
					{ environments_eq_any_item: $environmentsFilter },
					{
						and: [
							{ custom_fields_ne_tuple_key: $environmentCustomFieldsNeTupleKey }
							{ environments_eq_any_item: $environmentsEqAnyItem }
						]
					}
				]
			},
			{
				or: [
					{ flows_eq_any_item: $flowsFilter },
					{ custom_fields_eq_any_item_for_any_value: $flowsCustomFieldsFilter },
					{ custom_fields_eq_any_item_for_any_value: $otherCustomFieldsFilter }
				]
			},
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $unitIdCustomFieldsFilter },
					{ custom_fields_ne_tuple_key: $unitIdCustomFieldsNeTupleKey }
				]
			}
		]
	) {
		run_id
		test_name
		total_issues
		critical_issues
		run_time
		custom_fields
		environments
		flows
		test_path
		property_ids
	}
	total: wsdk_latest_test_runs(
		text_contains: $textSearch
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
		and: [
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter },
					{ environments_eq_any_item: $environmentsFilter },
					{
						and: [
							{ custom_fields_ne_tuple_key: $environmentCustomFieldsNeTupleKey }
							{ environments_eq_any_item: $environmentsEqAnyItem }
						]
					}
				]
			},
			{
				or: [
					{ flows_eq_any_item: $flowsFilter },
					{ custom_fields_eq_any_item_for_any_value: $flowsCustomFieldsFilter },
					{ custom_fields_eq_any_item_for_any_value: $otherCustomFieldsFilter }
				]
			},
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $unitIdCustomFieldsFilter },
					{ custom_fields_ne_tuple_key: $unitIdCustomFieldsNeTupleKey }
				]
			}
		]
	) {
		run_id_count
	}
	unfiltered_total: wsdk_test_runs {
		run_id_count
	}
}
